import { useState, useEffect } from 'react';
import { Info, AlertTriangle, CheckCircle, X } from 'lucide-react';
import { api } from '@/App';

import { logger } from '@/utils/logger';
export default function AnnouncementBanner() {
  const [announcements, setAnnouncements] = useState([]);
  const [dismissed, setDismissed] = useState([]);

  useEffect(() => {
    fetchAnnouncements();
    // Load dismissed announcements from localStorage
    const stored = localStorage.getItem('dismissed_announcements');
    if (stored) {
      setDismissed(JSON.parse(stored));
    }
  }, []);

  const fetchAnnouncements = async () => {
    try {
      const response = await api.get('/announcements/active');
      setAnnouncements(response.data);
    } catch (error) {
      logger.error('Error fetching announcements:', error);
    }
  };

  const handleDismiss = (announcementId) => {
    const newDismissed = [...dismissed, announcementId];
    setDismissed(newDismissed);
    localStorage.setItem('dismissed_announcements', JSON.stringify(newDismissed));
  };

  const getTypeStyles = (type) => {
    switch (type) {
      case 'warning':
        return {
          bg: '#FEF3C7',
          border: '#F59E0B',
          text: '#92400E',
          icon: AlertTriangle
        };
      case 'success':
        return {
          bg: '#D1FAE5',
          border: '#10B981',
          text: '#065F46',
          icon: CheckCircle
        };
      case 'info':
      default:
        return {
          bg: '#DBEAFE',
          border: '#3B82F6',
          text: '#1E40AF',
          icon: Info
        };
    }
  };

  const visibleAnnouncements = announcements.filter(a => !dismissed.includes(a.id));

  if (visibleAnnouncements.length === 0) {
    return null;
  }

  return (
    <div className="w-full">
      {visibleAnnouncements.map((announcement) => {
        const styles = getTypeStyles(announcement.type);
        const Icon = styles.icon;

        return (
          <div
            key={announcement.id}
            className="relative px-4 py-3 border-b"
            style={{
              background: styles.bg,
              borderColor: styles.border
            }}
          >
            <div className="max-w-7xl mx-auto flex items-center justify-between gap-3">
              <div className="flex items-center gap-3 flex-1">
                {announcement.emoji && (
                  <span className="text-2xl flex-shrink-0">{announcement.emoji}</span>
                )}
                <Icon className="w-5 h-5 flex-shrink-0" style={{ color: styles.text }} />
                <p className="text-sm font-medium" style={{ color: styles.text }}>
                  {announcement.message}
                </p>
              </div>
              <button
                onClick={() => handleDismiss(announcement.id)}
                className="p-1 rounded-full hover:bg-black hover:bg-opacity-10 transition-colors flex-shrink-0"
                aria-label="Dismiss announcement"
              >
                <X className="w-4 h-4" style={{ color: styles.text }} />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
